import React from "react"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { ProviderManagement } from "@/components/admin/ProviderManagement"
import { CategoryManagement } from "@/components/admin/CategoryManagement"
import { WarehouseManagement } from "@/components/admin/WarehouseManagement"
import { PageHeader } from "@/components/ui/page-header"
import { Building2, Settings, Users, LayoutDashboard, FolderTree, MapPin } from "lucide-react"
import { useLanguage } from "@/hooks/useLanguage"

const AdminDashboard = () => {
  const { t } = useLanguage()
  const text = t.adminDashboard

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground transition-colors duration-300">
      <Header />

      <main className="flex-1 pb-20 pt-24">
        <div className="container mx-auto px-4">
          <PageHeader title={text.title} />

          <Tabs defaultValue="providers" className="space-y-8">
            <TabsList className="grid h-auto w-full grid-cols-2 bg-muted/50 p-1 md:w-[900px] md:grid-cols-6">
              <TabsTrigger value="overview" className="gap-2 py-3">
                <LayoutDashboard className="h-4 w-4" />
                <span className="hidden sm:inline">{text.overview}</span>
              </TabsTrigger>
              <TabsTrigger value="providers" className="gap-2 py-3">
                <Building2 className="h-4 w-4" />
                <span className="hidden sm:inline">{text.providers}</span>
              </TabsTrigger>
              <TabsTrigger value="categories" className="gap-2 py-3">
                <FolderTree className="h-4 w-4" />
                <span className="hidden sm:inline">{text.categories}</span>
              </TabsTrigger>
              <TabsTrigger value="warehouses" className="gap-2 py-3">
                <MapPin className="h-4 w-4" />
                <span className="hidden sm:inline">Almacenes</span>
              </TabsTrigger>
              <TabsTrigger value="users" className="gap-2 py-3">
                <Users className="h-4 w-4" />
                <span className="hidden sm:inline">{text.users}</span>
              </TabsTrigger>
              <TabsTrigger value="settings" className="gap-2 py-3">
                <Settings className="h-4 w-4" />
                <span className="hidden sm:inline">{text.settings}</span>
              </TabsTrigger>
            </TabsList>

            <TabsContent value="overview">
              <div className="empty-state py-32 text-muted-foreground">
                <LayoutDashboard className="mb-4 h-12 w-12 opacity-20" />
                <p>{text.overviewComingSoon}</p>
              </div>
            </TabsContent>

            <TabsContent value="providers">
              <ProviderManagement />
            </TabsContent>

            <TabsContent value="categories">
              <CategoryManagement />
            </TabsContent>

            <TabsContent value="warehouses">
              <WarehouseManagement />
            </TabsContent>

            <TabsContent value="users">
              <div className="empty-state py-32 text-muted-foreground">
                <Users className="mb-4 h-12 w-12 opacity-20" />
                <p>{text.usersComingSoon}</p>
              </div>
            </TabsContent>

            <TabsContent value="settings">
              <div className="empty-state py-32 text-muted-foreground">
                <Settings className="mb-4 h-12 w-12 opacity-20" />
                <p>{text.settingsComingSoon}</p>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default AdminDashboard

